/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { font, colors, spacing, visuallyHiddenCss } from '@chegg-ui/theme';
import styled from 'styled-components';
var helperTextHeight = font.size.px12;
var helperTextMargin = "".concat(10 / 16, "rem");
export var FormGroup = styled.div.withConfig({
  componentId: "sc-1ftnaog-0"
})(["position:relative;width:", ";", ""], function (_ref) {
  var width = _ref.width;
  return width || 'auto';
}, function (_ref2) {
  var errorText = _ref2.errorText,
      helperText = _ref2.helperText;
  return !helperText && !errorText && "margin-bottom: calc(".concat(helperTextHeight, " + ").concat(helperTextMargin, ");");
});
export var Label = styled.label.withConfig({
  componentId: "sc-1ftnaog-1"
})(["", ""], function (_ref3) {
  var visuallyHidden = _ref3.visuallyHidden,
      adjustToBackgroundColor = _ref3.adjustToBackgroundColor;
  return visuallyHidden ? visuallyHiddenCss : "\n  font-family: ".concat(font.family["default"], ";\n  font-size: ").concat(font.size.px12, ";\n  color: ").concat(adjustToBackgroundColor ? colors.white : colors.grey, ";\n  padding: 0px;\n  padding-bottom: 0.4375rem;\n  display: block;\n  font-weight: ").concat(font.weight.bold, ";\n  &:hover {\n    cursor: text;\n  }\n  ");
});
export var HelperText = styled.div.withConfig({
  componentId: "sc-1ftnaog-2"
})(["color:", ";font-family:", ";font-size:", ";height:", ";margin-top:", ";padding-left:", ";"], function (_ref4) {
  var adjustToBackgroundColor = _ref4.adjustToBackgroundColor;
  return adjustToBackgroundColor ? colors.white : colors.grey;
}, font.family["default"], font.size.px14, helperTextHeight, helperTextMargin, spacing.px16);
export var Error = styled(HelperText).withConfig({
  componentId: "sc-1ftnaog-3"
})(["color:", ";"], colors.errorRed);
export var TrailingIconPositioner = styled.div.withConfig({
  componentId: "sc-1ftnaog-4"
})(["position:absolute;top:50%;right:", ";transform:translateY(-50%);display:flex;", ""], spacing.px8, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && "color: ".concat(colors.grey, ";");
});
export var FloatingLabel = styled.label.withConfig({
  componentId: "sc-1ftnaog-5"
})(["position:absolute;font-family:", ";font-size:", ";color:", ";top:1.25rem;z-index:1;transition:all 0.2s ease-out;pointer-events:none;&:hover{cursor:text;}", " @media (prefers-reduced-motion:reduce){transition:none;}"], font.family["default"], font.size.px18, function (_ref6) {
  var adjustToBackgroundColor = _ref6.adjustToBackgroundColor;
  return adjustToBackgroundColor ? colors.white : colors.grey;
}, function (_ref7) {
  var isFloating = _ref7.isFloating;
  return isFloating && "\n      top: ".concat(spacing.px8, ";\n      font-size: ").concat(font.size.px12, ";\n      font-weight: ").concat(font.weight.bold, ";\n    ");
});
export var FloatingHelperText = styled(HelperText).withConfig({
  componentId: "sc-1ftnaog-6"
})(["padding-left:0;"]);
export var FloatingError = styled(Error).withConfig({
  componentId: "sc-1ftnaog-7"
})(["padding-left:0;"]);
export var FloatingTrailingIconPositioner = styled.div.withConfig({
  componentId: "sc-1ftnaog-8"
})(["position:absolute;top:70%;transform:translateY(-50%);right:0;display:flex;pointer-events:none;transition:all 0.2s ease-out;@media (prefers-reduced-motion:reduce){transition:none;}", " ", ""], function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && "color: ".concat(colors.grey, ";");
}, function (_ref9) {
  var adjustToBackgroundColor = _ref9.adjustToBackgroundColor;
  return adjustToBackgroundColor && "color: ".concat(colors.white, ";");
});